import React, {Component} from 'react';
import {CoreActions} from '../store/actionCreators';
import {HashRouter, Route, Switch} from 'react-router-dom';
import NestSubRouter from './routers/NestSubRouter';
import ThermostatsSubRouter from './routers/ThermostatsSubRouter';
import IntroPage from './pages/IntroPage';
import {getOS} from '../lib/functions';

class App extends Component {
  constructor(props) {
    super(props);

    const OS = getOS(window.navigator.userAgent);
    CoreActions.setOS(OS);
  }

  render() {
    return (
      <HashRouter>
        <Switch>
          <Route path={'/intro/:lang'} component={IntroPage}/>
          <Route path={'/thermostats/nest'} component={NestSubRouter}/>
          <Route path={'/thermostats/ecobeehome'} component={ThermostatsSubRouter}/>
          <Route path={'/thermostats/sensi'} component={ThermostatsSubRouter}/>
        </Switch>
      </HashRouter>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/app/App.js